import { Icon } from 'components'
import { ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

export const MessageError = ({
  className = '',
  children,
  ...rest
}: ComponentProps<'div'>) => {
  if (!children) {
    return <></>
  }

  return (
    <div
      role="alert"
      className={twMerge('flex items-center gap-x-1 text-error-500', className)}
      {...rest}
    >
      <Icon face="warning" size="sm" variant="round" />
      <span className="text-caption">{children}</span>
    </div>
  )
}
